export const PROJECT_STATIONS = [
  "SS-750 Cragin",
  "SS-793 Laramie",
  "DCY-310 Austin",
  "TSS-30 Columbus",
  "DCY-365 Campbell",
  "TSS-67 Congress",
  "SS-798 Carroll",
  "TSS-38 Humboldt",
  "TSS-50 Rockwell",
  "TSS-148 West Loop",
  "TSS-82 Crosby",
  "SS-767 Division",
  "SS-761 Wendell",
  "TDC-785 Ontario",
  "TSS-65 Ohio",
  "TSS-34 Kingsbury",
  "TDC-745 I.C. Air Rights",
  "SS-796 Lake",
  "TSS-45 Jefferson",
  "TSS-49 Plymouth",
  "TSS-68 LaSalle",
  "DCY-315 Northerly Island",
  "TSS-126 State",
  "DCY-314 17th St.",
  "TSS-197 Taylor",
  "TSS-153 Taylor",
  "TSS-90 DeKoven",
  "TSS-36 Madison",
  "TSS-87 Dearborn",
  "TDC-714 Medical Center",
  "TSS-11 Fisk Shop",
  "TSS-58 Grand",
  "ESSY323 DUPAGE WATER COMMISSION",
  "ESSY440 ADM MILLING COMPANY",
  "ESSY442 FULTON MARKET STORAGE",
  "ESSY448 SUNSTRAND CORP. (AMCO)",
  "ESSY488 CERMAK PUMPING STATION",
  "ESSY513 JOANNA WESTERN MILLS CO",
  "ESSY517 MCCORMICK DISPLAY",
  "ESSY521 BLAIR VINYLWELD INC. AT",
  "ESSY527 PRODUCE TERM BLUE ISLAND",
  "ESSY530-1 RYERSON STEEL",
  "ESSY533-1 SEARS ROEBUCK (Outside)",
  "ESSY533-1A SEARS ROEBUCK (In Building)",
  "ESSY539 VA HOSPITAL",
  "ESSY540-1A U of I RESEARCH",
  "ESSY606-3 COOK COUNTY POWER HOUSE",
  "ESSY606-4 COOK COUNTY HOSPITAL",
  "ESSY427 LAKE SHORE PLACE",
  "ESSY432 CHICAGO AVE. PUMPING STA.",
  "ESSY449 IBT ERIE",
  "ESSY457-1A MERCHANDISE MART (9th Fl)",
  "ESSY457-2 MERCHANDISE MART (DOCK)",
  "ESSY457-4 MERCHANDISE MART",
  "ESSY461-1 NORTHWESTERN UNIVERSITY",
  "ESSY464 DANTIS INC.",
  "ESSY498 COOK COUNTY BUILDING",
  "ESSY636-1 SOLDIER FIELD",
  "ESSY654 DALEY CENTER",
  "ESSY655 ATLAS FASTENER",
  "ESSY691-B MOODY BIBLE INSTITUTE",
  "ESSY313 US RR RETIREMENT BOARD",
  "ESSY316 GRANT SCHOOL",
  "ESSY318 BRANCH'S CANDY",
  "ESSY430-1 CHICAGO PARK GARFIELD",
  "ESSY435 FULTON CARROL COMPANY",
  "ESSY441 UNILEVER",
  "ESSY451 LAKEWOOD INDUSTRIES",
  "ESSY452 LEAF BRANDS (Ribbon Webbing)",
  "ESSY458 PLAYSCHOOL",
  "ESSY471 SUNGATE",
  "ESSY475 ZENITH RADIO CORP.",
  "Unknown"
];

export const CURRENT_LOCATIONS = [
  "Main yard",
  "On truck",
  "At station",
  "Installed",
  "Returned",
  "Other",
];

// Legacy compat: kept so old shipments still render
export const CURRENT_LOCATIONS_LEGACY = [
  "Main yard",
  "TSS 45 control house",
  "On truck",
  "At station",
  "Installed",
  "Returned",
  "Other",
];

export const WORKFLOW_STAGES = [
  "Received",
  "Stocked",
  "Destocked",
  "Delivered",
  "Installed",
  "Returned",
  "Requested by Crew",
];

// 4-step linear workflow shown on the progress bar (in order)
export const WORKFLOW_STEPS = ["Received", "Stocked", "Destocked", "Delivered"];

export const WORKFLOW_COLORS = {
  Received: "text-blue-700 bg-blue-100 border-blue-700",
  Stocked: "text-amber-800 bg-amber-100 border-amber-700",
  Destocked: "text-orange-800 bg-orange-100 border-orange-700",
  Delivered: "text-emerald-800 bg-emerald-100 border-emerald-700",
  Installed: "text-green-800 bg-green-100 border-green-700",
  Returned: "text-rose-800 bg-rose-100 border-rose-700",
  "Requested by Crew": "text-purple-800 bg-purple-100 border-purple-700",
};

export const STORAGE_DETAILS = [
  "Bay SS-750 Cragin",
  "Bay SS-793 Laramie",
  "Bay DCY-310 Austin",
  "Bay TSS-30 Columbus",
  "Bay DCY-365 Campbell",
  "Bay TSS-67 Congress",
  "Bay SS-798 Carroll",
  "Bay TSS-38 Humboldt",
  "Bay TSS-50 Rockwell",
  "Bay TSS-148 West Loop",
  "Bay TSS-82 Crosby",
  "Bay SS-767 Division",
  "Bay SS-761 Wendell",
  "Bay TDC-785 Ontario",
  "Bay TSS-65 Ohio",
  "Bay TSS-34 Kingsbury",
  "Bay TDC-745 I.C. Air Rights",
  "Bay SS-796 Lake",
  "Bay TSS-45 Jefferson",
  "Bay TSS-49 Plymouth",
  "Bay TSS-68 LaSalle",
  "Bay DCY-315 Northerly Island",
  "Bay TSS-126 State",
  "Bay DCY-314 17th St.",
  "Bay TSS-197 Taylor",
  "Bay TSS-153 Taylor",
  "Bay TSS-90 DeKoven",
  "Bay TSS-36 Madison",
  "Bay TSS-87 Dearborn",
  "Bay TDC-714 Medical Center",
  "Bay TSS-11 Fisk Shop",
  "Bay TSS-58 Grand",
  "Bay ESSY323 DUPAGE WATER COMMISSION",
  "Bay ESSY440 ADM MILLING COMPANY",
  "Bay ESSY442 FULTON MARKET STORAGE",
  "Bay ESSY448 SUNSTRAND CORP. (AMCO)",
  "Bay ESSY488 CERMAK PUMPING STATION",
  "Bay ESSY513 JOANNA WESTERN MILLS CO",
  "Bay ESSY517 MCCORMICK DISPLAY",
  "Bay ESSY521 BLAIR VINYLWELD INC. AT",
  "Bay ESSY527 PRODUCE TERM BLUE ISLAND",
  "Bay ESSY530-1 RYERSON STEEL",
  "Bay ESSY533-1 SEARS ROEBUCK (Outside)",
  "Bay ESSY533-1A SEARS ROEBUCK (In Building)",
  "Bay ESSY539 VA HOSPITAL",
  "Bay ESSY540-1A U of I RESEARCH",
  "Bay ESSY606-3 COOK COUNTY POWER HOUSE",
  "Bay ESSY606-4 COOK COUNTY HOSPITAL",
  "Bay ESSY427 LAKE SHORE PLACE",
  "Bay ESSY432 CHICAGO AVE. PUMPING STA.",
  "Bay ESSY449 IBT ERIE",
  "Bay ESSY457-1A MERCHANDISE MART (9th Fl)",
  "Bay ESSY457-2 MERCHANDISE MART (DOCK)",
  "Bay ESSY457-4 MERCHANDISE MART",
  "Bay ESSY461-1 NORTHWESTERN UNIVERSITY",
  "Bay ESSY464 DANTIS INC.",
  "Bay ESSY498 COOK COUNTY BUILDING",
  "Bay ESSY636-1 SOLDIER FIELD",
  "Bay ESSY654 DALEY CENTER",
  "Bay ESSY655 ATLAS FASTENER",
  "Bay ESSY691-B MOODY BIBLE INSTITUTE",
  "Bay ESSY313 US RR RETIREMENT BOARD",
  "Bay ESSY316 GRANT SCHOOL",
  "Bay ESSY318 BRANCH'S CANDY",
  "Bay ESSY430-1 CHICAGO PARK GARFIELD",
  "Bay ESSY435 FULTON CARROL COMPANY",
  "Bay ESSY441 UNILEVER",
  "Bay ESSY451 LAKEWOOD INDUSTRIES",
  "Bay ESSY452 LEAF BRANDS (Ribbon Webbing)",
  "Bay ESSY458 PLAYSCHOOL",
  "Bay ESSY471 SUNGATE",
  "Bay ESSY475 ZENITH RADIO CORP.",
  "Unknown"
];

export const STATUSES = [
  "Received",
  "In yard",
  "At station",
  "Installed",
  "Returned",
  "Requested by Crew",
];

export const YARD_EXTRA_STATUSES = [
  "Received - In Main Yard",
  "Stored in Yard",
  "Ready for Pickup",
  "Staged for Delivery",
];

export const STATUSES_FOR_LOCATION = (location) => {
  if (location === "Main yard") {
    return [...YARD_EXTRA_STATUSES, ...STATUSES];
  }
  return STATUSES;
};

export const PREP_QUEUE_STATUSES = [
  "Not Needed",
  "Pending Preparation",
  "Preparing",
  "Ready for Handover",
  "Completed",
];

export const PREP_COLORS = {
  "Not Needed": "text-slate-500 bg-slate-100",
  "Pending Preparation": "text-amber-700 bg-amber-100",
  Preparing: "text-blue-700 bg-blue-100",
  "Ready for Handover": "text-purple-700 bg-purple-100",
  Completed: "text-green-700 bg-green-100",
};

export const STATUS_COLORS = {
  Received: "text-blue-700 bg-blue-100",
  "In yard": "text-slate-700 bg-slate-100",
  "At station": "text-indigo-700 bg-indigo-100",
  Installed: "text-green-700 bg-green-100",
  Returned: "text-rose-700 bg-rose-100",
};

export function formatLocalDateTime(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString(undefined, {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export function formatLocalDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString(undefined, {
      year: "numeric",
      month: "short",
      day: "2-digit",
    });
  } catch {
    return iso;
  }
}

export const PRIORITIES = ["Low", "Normal", "High", "Urgent"];

export const PRIORITY_STYLES = {
  Urgent: {
    pill: "bg-rose-700 text-white border-2 border-rose-900",
    border: "border-l-rose-700",
    label: "URGENT",
    chip: "bg-rose-100 text-rose-800 border-2 border-rose-700",
  },
  High: {
    pill: "bg-orange-600 text-white border-2 border-orange-800",
    border: "border-l-orange-600",
    label: "HIGH",
    chip: "bg-orange-100 text-orange-800 border-2 border-orange-700",
  },
  Normal: {
    pill: "bg-slate-200 text-slate-700 border-2 border-slate-400",
    border: "border-l-slate-300",
    label: "Normal",
    chip: "bg-slate-100 text-slate-700 border-2 border-slate-300",
  },
  Low: {
    pill: "bg-slate-100 text-slate-500 border-2 border-slate-300",
    border: "border-l-slate-200",
    label: "Low",
    chip: "bg-slate-50 text-slate-500 border-2 border-slate-200",
  },
};

// Color-codes ETA based on minutes-from-now
export function etaColor(iso) {
  if (!iso) return "text-slate-500";
  try {
    const ms = new Date(iso).getTime() - Date.now();
    const hrs = ms / 3600000;
    if (hrs < 0) return "text-rose-700"; // overdue
    if (hrs <= 2) return "text-green-700";
    if (hrs <= 24) return "text-amber-700";
    return "text-slate-700";
  } catch {
    return "text-slate-500";
  }
}

// localStorage helper for last-used Project_Station
const LAST_STATION_KEY = "rougee:last-station";

export function getLastUsedStation() {
  try {
    return localStorage.getItem(LAST_STATION_KEY) || "";
  } catch {
    return "";
  }
}

export function setLastUsedStation(station) {
  if (!station) return;
  try {
    localStorage.setItem(LAST_STATION_KEY, station);
  } catch {}
}
